export interface TabItem {
  id: string;
  label: string;
  count?: number;
}

interface TabsProps {
  tabs: TabItem[];
  active: string;
  onChange: (id: string) => void;
}

export default function Tabs({ tabs, active, onChange }: TabsProps) {
  return (
    <div className="border-b border-background-200">
      <div className="flex items-center gap-1 overflow-x-auto">
        {tabs.map((tab) => {
          const isActive = tab.id === active;
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onChange(tab.id)}
              className={[
                'relative flex items-center gap-2 whitespace-nowrap px-5 py-3 text-sm font-semibold transition-colors',
                isActive ? 'text-primary-600' : 'text-secondary-400 hover:text-secondary-500',
              ].join(' ')}
            >
              <span>{tab.label}</span>
              {typeof tab.count === 'number' && (
                <span
                  className={[
                    'flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-[11px] font-semibold',
                    isActive
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-background-200 text-foreground-500',
                  ].join(' ')}
                >
                  {tab.count}
                </span>
              )}
              {isActive && (
                <span className="absolute inset-x-0 -bottom-px h-0.5 rounded-full bg-primary-500"></span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}